import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { Quality } from '../models';
import { BaseEditService } from './base';
import { HttpService } from './http.service';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class QualityService extends BaseEditService<Quality, Quality> {
  readonly qualitySelected$ = new Subject<string>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('Quality', $localize`Quality`, httpService, notificationService);
  }
}
